export enum PermissionType {
  OBJECT_CREATOR_ID
}
